(function(){
'use strict';

function qsa(selector, root){
  return Array.prototype.slice.call((root || document).querySelectorAll(selector));
}

function safeReferralCode(value){
  return /^[A-Za-z0-9_-]{3,64}$/.test(value || '') ? value : '';
}

function captureReferral(){
  try {
    var params = new URLSearchParams(window.location.search);
    var ref = safeReferralCode(params.get('ref') || '');
    if(ref) localStorage.setItem('pham_referral_code', ref);
  } catch (e) { /* ignore storage/query failures */ }
}

function storedReferral(){
  try {
    return safeReferralCode(localStorage.getItem('pham_referral_code') || '');
  } catch (e) {
    return '';
  }
}

function formatMoney(cents, currency){
  var amount = (Number(cents) || 0) / 100;
  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: currency || 'USD'
    }).format(amount);
  } catch (e) {
    return '$' + amount.toFixed(2);
  }
}

function engineErrorMessage(code){
  var messages = {
    object_number_taken: 'That object number was just claimed. Select another number.',
    object_number_out_of_range: 'Select a valid object number for this edition.',
    identity_not_claimed: 'Object Identity is not unlocked for this collector.',
    customer_login_required: 'Sign in with the collector account linked to your reservation.',
    reservation_not_found: 'No active reservation was found for this collector account.',
    standby_not_open: 'Standby is not open yet.',
    standby_already_joined: 'This collector is already in the standby queue.',
    size_preference_required: 'Enter a size preference before joining standby.',
    invalid_email: 'Enter a valid email address.',
    invalid_signature: 'Collector session verification failed. Refresh the page and try again.',
    stale_request: 'This collector session expired. Refresh the page and try again.'
  };
  return messages[code] || 'Unable to complete this request. Please try again.';
}

function proxyRequest(root, route, options){
  var base = (root.dataset.engineProxy || '/apps/pham-edition').replace(/\/$/, '');
  var requestOptions = Object.assign({
    method: 'GET',
    headers: { 'Accept': 'application/json' },
    credentials: 'same-origin'
  }, options || {});

  if(requestOptions.body && typeof requestOptions.body !== 'string'){
    requestOptions.headers = Object.assign({}, requestOptions.headers, {
      'Content-Type': 'application/json'
    });
    requestOptions.body = JSON.stringify(requestOptions.body);
  }

  return fetch(base + route, requestOptions).then(function(response){
    return response.json().catch(function(){ return {}; }).then(function(payload){
      if(!response.ok || payload.ok === false){
        var error = new Error(payload.error || 'proxy_request_failed');
        error.code = payload.error || 'proxy_request_failed';
        error.payload = payload;
        throw error;
      }
      return payload;
    });
  });
}

function readCampaignContext(){
  var node = document.querySelector('[data-pham-campaign-context]');
  if(!node) return null;
  try { return JSON.parse(node.textContent || '{}'); }
  catch (e) { return null; }
}

function effectiveCampaignState(context, state){
  var normalized = String(state || 'prelaunch');
  if(normalized === 'reservation_open'){
    var commerceReady = context && context.commerceReady === true;
    var lookbookReady = !context || context.includeLookbook !== true || context.lookbookReady === true;
    if(!commerceReady || !lookbookReady) return 'prelaunch';
  }
  return normalized;
}

function campaignPresentation(context, state){
  var presentation = {
    url: context.editionPageUrl || '/pages/edition-01',
    entryLabel: null,
    primaryLabel: null,
    price: null,
    status: null,
    acquisitionTitle: context.productCode || context.product || 'PHAM-001',
    acquisitionSubtitle: context.edition || 'EDITION 01',
    acquisitionCopy: null,
    acquisitionFacts: []
  };

  switch(state){
    case 'reservation_open':
      presentation.url = context.reservationPageUrl || '/pages/reserve-edition-01';
      presentation.entryLabel = 'RESERVE ' + (context.edition || 'EDITION');
      presentation.primaryLabel = 'RESERVE PRIORITY ACCESS';
      presentation.price = context.reservationPrice || '$24.99';
      presentation.status = 'PRIORITY RESERVATION OPEN';
      presentation.acquisitionSubtitle = 'PRIORITY RESERVATION';
      presentation.acquisitionCopy = 'A confirmed reservation holds one of 50 Edition 01 allocations while capacity remains.';
      presentation.acquisitionFacts = [
        'SECURES ONE EDITION 01 ALLOCATION',
        'RESERVATION CREDITED TOWARD THE $199 OBJECT',
        'COLLECTOR LOOKBOOK INCLUDED'
      ];
      break;
    case 'reservation_full':
      presentation.url = context.standbyPageUrl || '/pages/standby';
      presentation.entryLabel = 'JOIN STANDBY';
      presentation.primaryLabel = 'JOIN STANDBY · FREE';
      presentation.price = 'FREE';
      presentation.status = 'EDITION RESERVED · STANDBY OPEN';
      presentation.acquisitionSubtitle = 'STANDBY ACCESS';
      presentation.acquisitionCopy = 'Edition 01 is currently fully reserved. Join the standby queue without payment.';
      presentation.acquisitionFacts = [
        'EDITION 01 ALLOCATION CURRENTLY FULL',
        'JOIN STANDBY AT NO COST',
        'OFFERS RELEASE IN QUEUE ORDER WHEN SPACE OPENS'
      ];
      break;
    case 'final_payment':
      presentation.url = context.collectorPageUrl || '/pages/reservation-status';
      presentation.entryLabel = 'COLLECTOR ACCESS';
      presentation.primaryLabel = 'COMPLETE ACQUISITION';
      presentation.price = context.balanceDue || '$174.01';
      presentation.status = 'ACQUISITION WINDOW OPEN';
      presentation.acquisitionSubtitle = 'ACQUISITION WINDOW';
      presentation.acquisitionCopy = 'Reserved collectors can complete the remaining balance during the active acquisition window.';
      presentation.acquisitionFacts = [
        'YOUR RESERVATION CREDIT IS APPLIED',
        'COMPLETE THE REMAINING BALANCE WITHIN THE WINDOW',
        'COLLECTOR ACCESS TRACKS THE OBJECT RECORD'
      ];
      break;
    case 'sold_out':
      presentation.entryLabel = 'VIEW EDITION';
      presentation.primaryLabel = 'VIEW EDITION';
      presentation.status = 'EDITION CLOSED';
      presentation.acquisitionSubtitle = 'EDITION CLOSED';
      presentation.acquisitionCopy = 'Edition 01 is closed. The object remains visible as part of the PHAM archive.';
      break;
    case 'archived':
      presentation.entryLabel = 'VIEW ARCHIVE';
      presentation.primaryLabel = 'VIEW ARCHIVE';
      presentation.status = 'ARCHIVED';
      presentation.acquisitionSubtitle = 'ARCHIVED';
      presentation.acquisitionCopy = 'Edition 01 is archived and will not return to production.';
      break;
    default:
      return null;
  }

  return presentation;
}

function applyGlobalCampaignState(context, state){
  var presentation = campaignPresentation(context, state);
  if(!presentation) return;

  qsa('[data-pham-campaign-entry]').forEach(function(link){
    link.href = presentation.url;
    if(presentation.entryLabel){
      link.innerHTML = presentation.entryLabel + ' <span aria-hidden="true">&#8599;</span>';
    }
  });

  qsa('[data-pham-campaign-primary]').forEach(function(link){
    link.href = presentation.url;
    var label = link.querySelector('span');
    if(label && presentation.primaryLabel) label.textContent = presentation.primaryLabel;
  });

  qsa('[data-pham-campaign-price]').forEach(function(node){
    if(presentation.price != null) node.textContent = presentation.price;
  });

  qsa('[data-pham-campaign-status]').forEach(function(node){
    if(presentation.status) node.textContent = presentation.status;
  });

  qsa('[data-pham-acquisition-title]').forEach(function(node){
    if(presentation.acquisitionTitle) node.textContent = presentation.acquisitionTitle;
  });

  qsa('[data-pham-acquisition-subtitle]').forEach(function(node){
    if(presentation.acquisitionSubtitle) node.textContent = presentation.acquisitionSubtitle;
  });

  qsa('[data-pham-acquisition-copy]').forEach(function(node){
    if(presentation.acquisitionCopy) node.textContent = presentation.acquisitionCopy;
  });

  qsa('[data-pham-acquisition-facts]').forEach(function(list){
    var facts = Array.isArray(presentation.acquisitionFacts) ? presentation.acquisitionFacts : [];
    var items = qsa('[data-pham-acquisition-fact]', list);
    list.hidden = facts.length === 0;
    items.forEach(function(item, index){
      item.textContent = facts[index] || '';
      item.hidden = !facts[index];
    });
  });

  var indexLabels = {
    reservation_open: ['RESERVATION OPEN', 'reservation-open'],
    reservation_full: ['RESERVED / STANDBY', 'reserved-standby'],
    final_payment: ['ACQUISITION OPEN', 'acquisition-open'],
    sold_out: ['CLOSED', 'closed'],
    archived: ['ARCHIVED', 'archived']
  };

  qsa('[data-pham-edition-index-status]').forEach(function(node){
    var config = indexLabels[state];
    if(!config) return;
    node.textContent = config[0];
    node.className = 'pham-edition-index__status pham-edition-index__status--' + config[1];
  });

  qsa('[data-pham-campaign-cta]').forEach(function(link){
    link.href = presentation.url;

    var label = link.querySelector('.pham-product-spotlight__add-label, .pham-product-main__cta-label');
    if(label && presentation.primaryLabel) label.textContent = presentation.primaryLabel;

    var price = link.querySelector('.pham-product-spotlight__add-price');
    if(price && presentation.price != null) price.textContent = presentation.price;
  });

  document.documentElement.dataset.phamCampaignState = state;
}

function mountGlobalCampaignRuntime(){
  if(document.documentElement.dataset.phamCampaignRuntimeMounted === 'true') return;
  document.documentElement.dataset.phamCampaignRuntimeMounted = 'true';

  var context = readCampaignContext();
  if(!context || !context.enabled || !context.engineEnabled) return;

  var base = String(context.engineProxy || '/apps/pham-edition').replace(/\/$/, '');
  var editionId = context.editionId || 'edition-01';

  fetch(base + '/campaign?edition=' + encodeURIComponent(editionId), {
    method:'GET',
    headers:{'Accept':'application/json'},
    credentials:'same-origin'
  })
  .then(function(response){
    return response.json().catch(function(){ return {}; }).then(function(payload){
      if(!response.ok || payload.ok === false) throw new Error(payload.error || 'campaign_state_unavailable');
      return payload;
    });
  })
  .then(function(payload){
    if(!payload || !payload.edition) return;
    window.__PHAM_CAMPAIGN_LIVE__ = payload;
    var effectiveState = effectiveCampaignState(context, payload.edition.state);
    document.documentElement.dataset.phamCampaignState = effectiveState;
    applyGlobalCampaignState(context, effectiveState);
  })
  .catch(function(){
    // Server-rendered Theme Settings remain the safe fallback.
  });
}

function mountIdentity(root){
  if(root.dataset.phamMounted === 'true') return;
  root.dataset.phamMounted = 'true';

  var name = root.querySelector('[data-pham-id-name]');
  var inscription = root.querySelector('[data-pham-id-inscription]');
  var outName = root.querySelector('[data-pham-preview-name]');
  var outInscription = root.querySelector('[data-pham-preview-inscription]');
  var outNumber = root.querySelector('[data-pham-preview-number]');
  var count = root.querySelector('[data-pham-inscription-count]');
  var numberInput = root.querySelector('[data-pham-id-number-input]');
  var submit = root.querySelector('[data-pham-identity-submit]');
  var form = root.querySelector('.pham-identity-form');
  var publicIdentity = root.querySelector('input[name="contact[Public identity]"]');
  var result = root.querySelector('[data-pham-identity-result]');
  var engineEnabled = root.dataset.engineEnabled === 'true';
  var buttons = qsa('[data-pham-object-number]', root);

  function sync(){
    if(outName) outName.textContent = (name && name.value.trim()) || 'COLLECTOR ID';
    if(outInscription) outInscription.textContent = (inscription && inscription.value.trim()) || 'YOUR INSCRIPTION';
    if(count && inscription) count.textContent = String(inscription.value.length) + '/40';
  }

  if(name) name.addEventListener('input', sync);
  if(inscription) inscription.addEventListener('input', sync);

  buttons.forEach(function(btn){
    btn.addEventListener('click', function(){
      buttons.forEach(function(x){
        x.classList.remove('is-selected');
        x.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      if(outNumber) outNumber.textContent = btn.dataset.phamObjectNumber + '/' + (root.dataset.editionSize || '50');
      if(numberInput) numberInput.value = btn.dataset.phamObjectNumber || '';
      if(submit) submit.disabled = !numberInput || numberInput.value === '';
    });
  });

  if(submit) submit.disabled = !numberInput || numberInput.value === '';

  if(engineEnabled && form){
    form.addEventListener('submit', function(event){
      event.preventDefault();
      if(!submit || submit.disabled || !numberInput || !numberInput.value) return;

      submit.disabled = true;
      submit.classList.add('is-busy');
      submit.textContent = 'Saving Identity…';
      if(result) result.hidden = true;

      proxyRequest(root, '/identity/configure', {
        method: 'POST',
        body: {
          alias: name ? name.value : '',
          inscription: inscription ? inscription.value : '',
          preferredNumber: Number(numberInput.value),
          publicIdentity: Boolean(publicIdentity && publicIdentity.checked)
        }
      })
      .then(function(payload){
        if(result){
          result.textContent = 'IDENTITY RECORDED · OBJECT ' +
            String(payload.identity.preferredNumber).padStart(2, '0') +
            '/' + (root.dataset.editionSize || '50') +
            ' IS NOW LOCKED TO YOUR RESERVATION.';
          result.hidden = false;
        }
        buttons.forEach(function(btn){ btn.disabled = true; });
        if(name) name.disabled = true;
        if(inscription) inscription.disabled = true;
        if(publicIdentity) publicIdentity.disabled = true;
        submit.textContent = 'Identity recorded';
      })
      .catch(function(error){
        if(result){
          result.textContent = engineErrorMessage(error.code);
          result.hidden = false;
        }
        submit.disabled = false;
        submit.classList.remove('is-busy');
        submit.textContent = 'Submit Identity request';
      });
    });
  }

  sync();
}

function mountReferral(root){
  if(root.dataset.phamReferralMounted === 'true') return;
  root.dataset.phamReferralMounted = 'true';

  var button = root.querySelector('[data-pham-copy-referral]');
  var code = root.querySelector('[data-pham-referral-value]');
  var count = root.querySelector('[data-pham-referral-count]');

  if(button && code){
    button.addEventListener('click', function(){
      var value = code.textContent.trim();
      if(!value || value === 'PENDING' || value === 'LOADING…') return;

      if(navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(value).then(function(){
          button.textContent = 'COPIED';
          window.setTimeout(function(){ button.textContent = 'COPY'; }, 1200);
        });
      }
    });
  }

  if(root.dataset.engineEnabled !== 'true') return;

  if(code) code.textContent = 'LOADING…';

  proxyRequest(root, '/status')
    .then(function(payload){
      var referralCode = payload.reservation && payload.reservation.collectorReferralCode
        ? payload.reservation.collectorReferralCode
        : '';
      if(code){
        code.textContent = referralCode
          ? (root.dataset.referralTarget || '') + encodeURIComponent(referralCode)
          : 'PENDING';
      }
      if(count && payload.referral){
        count.textContent = String(payload.referral.verifiedCount || 0) + ' / ' +
          String(payload.referral.requiredCount || 1);
      }
    })
    .catch(function(){
      if(code && code.textContent === 'LOADING…') code.textContent = 'PENDING';
    });
}

function syncSizeSelect(select, sizes){
  if(!select || !Array.isArray(sizes) || !sizes.length) return;

  var current = select.value;
  var placeholder = select.querySelector('option[value=""]');
  select.innerHTML = '';

  var emptyOption = document.createElement('option');
  emptyOption.value = '';
  emptyOption.textContent = placeholder ? placeholder.textContent : 'SELECT SIZE';
  select.appendChild(emptyOption);

  sizes.forEach(function(size){
    var value = String(size || '').trim();
    if(!value) return;
    var option = document.createElement('option');
    option.value = value;
    option.textContent = value;
    select.appendChild(option);
  });

  if(current && sizes.some(function(size){ return String(size) === current; })){
    select.value = current;
  } else {
    select.value = '';
  }
}

function mountReservation(root){
  if(root.dataset.phamReservationMounted === 'true') return;
  root.dataset.phamReservationMounted = 'true';

  var checks = qsa('[data-pham-required-consent]', root);
  var submit = root.querySelector('[data-pham-reservation-submit]');
  var identity = root.querySelector('[data-pham-identity-upgrade]');
  var sizePreference = root.querySelector('[data-pham-size-preference]');
  var sizeChoices = qsa('[data-pham-size-choice]', root);
  var sizeStatus = root.querySelector('[data-pham-size-status]');
  var totals = qsa('[data-pham-reservation-total]', root);
  var identitySummary = root.querySelector('[data-pham-identity-summary]');
  var reservationImage = root.querySelector('[data-pham-reservation-image]');
  var reservationThumbs = qsa('[data-pham-reservation-thumb]', root);
  var error = root.querySelector('[data-pham-reservation-error]');

  var canCheckout = root.dataset.canCheckout === 'true';
  var engineEnabled = root.dataset.engineEnabled === 'true';
  var liveReservationOpen = !engineEnabled;
  var reservationVariantId = root.dataset.reservationVariantId || '';
  var identityVariantId = root.dataset.identityVariantId || '';
  var lookbookVariantId = root.dataset.lookbookVariantId || '';
  var includeLookbook = root.dataset.includeLookbook === 'true';
  var lookbookReady = root.dataset.lookbookReady === 'true';
  var reservationPrice = parseInt(root.dataset.reservationPriceCents || '2499', 10);
  var identityPrice = parseInt(root.dataset.identityPriceCents || '500', 10);
  var currency = root.dataset.currency || 'USD';
  var edition = root.dataset.edition || '';
  var productCode = root.dataset.productCode || '';

  function consentReady(){
    return checks.length > 0 && checks.every(function(x){ return x.checked; });
  }

  function syncSizeUI(){
    var selected = sizePreference ? String(sizePreference.value || '') : '';
    sizeChoices.forEach(function(button){
      var active = String(button.dataset.phamSizeChoice || '') === selected;
      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-checked', active ? 'true' : 'false');
    });
    if(sizeStatus) sizeStatus.textContent = selected ? ('SELECTED · ' + selected) : 'NOT SELECTED';
  }

  function sync(){
    var addIdentity = !!(identity && identity.checked && !identity.disabled);
    var dueToday = formatMoney(reservationPrice + (addIdentity ? identityPrice : 0), currency);
    totals.forEach(function(node){ node.textContent = dueToday; });
    if(identitySummary) identitySummary.hidden = !addIdentity;

    if(submit){
      var lookbookValid = !includeLookbook || (lookbookReady && lookbookVariantId !== '');
      var sizeReady = !!(sizePreference && String(sizePreference.value || '').trim());
      var ready = canCheckout && liveReservationOpen && consentReady() && sizeReady && reservationVariantId !== '' && lookbookValid;
      submit.disabled = !ready;
      submit.setAttribute('aria-disabled', ready ? 'false' : 'true');
      submit.classList.toggle('is-disabled', !ready);
    }
  }

  checks.forEach(function(x){ x.addEventListener('change', sync); });
  if(identity) identity.addEventListener('change', sync);
  if(sizePreference) sizePreference.addEventListener('change', function(){ syncSizeUI(); sync(); });
  sizeChoices.forEach(function(button){
    button.addEventListener('click', function(){
      if(!sizePreference) return;
      sizePreference.value = String(button.dataset.phamSizeChoice || '');
      sizePreference.dispatchEvent(new Event('change', { bubbles:true }));
    });
  });

  reservationThumbs.forEach(function(button){
    button.addEventListener('click', function(){
      var src = button.dataset.imageSrc || '';
      if(!reservationImage || !src) return;
      reservationImage.src = src;
      reservationThumbs.forEach(function(item){ item.classList.toggle('is-active', item === button); });
    });
  });

  if(submit){
    submit.addEventListener('click', function(){
      if(submit.disabled || !canCheckout || !liveReservationOpen) return;

      var referral = storedReferral();
      var items = [{
        id: Number(reservationVariantId),
        quantity: 1,
        properties: {
          '_PHAM Edition': edition,
          '_PHAM Product': productCode,
          '_PHAM Referral Code': referral,
          '_PHAM Size Preference': sizePreference ? sizePreference.value : '',
          'Reservation terms': 'Accepted',
          'Digital lookbook delivery': includeLookbook ? 'Included' : 'Not included'
        }
      }];

      if(includeLookbook && lookbookReady && lookbookVariantId){
        items.push({
          id: Number(lookbookVariantId),
          quantity: 1,
          properties: {
            '_PHAM Edition': edition,
            '_PHAM Product': productCode,
            '_PHAM Benefit': 'Collector Lookbook',
            'Digital delivery': 'Included with Priority Reservation'
          }
        });
      }

      if(identity && identity.checked && !identity.disabled && identityVariantId){
        items.push({
          id: Number(identityVariantId),
          quantity: 1,
          properties: {
            '_PHAM Edition': edition,
            '_PHAM Product': productCode,
            'Identity source': 'Paid upgrade'
          }
        });
      }

      submit.disabled = true;
      submit.classList.add('is-busy');
      submit.textContent = 'Preparing secure checkout…';
      if(error) error.hidden = true;

      fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:items})
      })
      .then(function(response){
        return response.json().then(function(payload){
          if(!response.ok) throw new Error(payload.description || payload.message || 'Unable to prepare reservation.');
          return payload;
        });
      })
      .then(function(){ window.location.assign('/checkout'); })
      .catch(function(err){
        if(error){
          error.textContent = err && err.message ? err.message : 'Unable to prepare reservation. Please try again.';
          error.hidden = false;
        }
        submit.disabled = false;
        submit.classList.remove('is-busy');
        submit.textContent = 'RESERVE PHAM-001';
        sync();
      });
    });
  }

  syncSizeUI();

  if(engineEnabled){
    proxyRequest(root, '/campaign?edition=' + encodeURIComponent(root.dataset.editionId || 'edition-01'))
      .then(function(payload){
        var state = payload && payload.edition ? payload.edition.state : '';
        liveReservationOpen = state === 'reservation_open';

        if(sizePreference && payload && payload.edition){
          syncSizeSelect(sizePreference, payload.edition.sizeOptions || []);
          syncSizeUI();
        }

        if(identity && payload && payload.counters && payload.edition){
          var identityClaimed = Number(payload.counters.identityClaimed || 0);
          var identityLimit = Number(payload.edition.identityLimit || 0);
          if(identityLimit > 0 && identityClaimed >= identityLimit){
            identity.checked = false;
            identity.disabled = true;
            var choice = identity.closest('.pham-reservation-upgrade__choice');
            if(choice) choice.classList.add('is-closed');
          }
        }

        if(!liveReservationOpen && error){
          error.textContent = state === 'reservation_full'
            ? 'Priority Reservation is fully allocated. Join the standby queue for the next released object.'
            : 'Priority Reservation is not currently open.';
          error.hidden = false;
        }

        sync();
      })
      .catch(function(){
        liveReservationOpen = false;
        if(error){
          error.textContent = 'Unable to verify live reservation availability. Checkout remains disabled for safety.';
          error.hidden = false;
        }
        sync();
      });
  }

  sync();
}

function mountStandby(root){
  if(root.dataset.phamStandbyMounted === 'true') return;
  root.dataset.phamStandbyMounted = 'true';

  if(root.dataset.engineEnabled !== 'true') return;

  var form = root.querySelector('.pham-standby-form');
  var liveForm = root.querySelector('[data-pham-standby-live-form]');
  var locked = root.querySelector('[data-pham-standby-live-locked]');
  if(!form) return;

  var liveStandbyOpen = false;
  var editionId = root.dataset.editionId || 'edition-01';
  var submit = root.querySelector('[data-pham-standby-submit]');
  var result = root.querySelector('[data-pham-standby-result]');
  var email = form.querySelector('input[name="contact[email]"]');
  var country = form.querySelector('input[name="contact[Country]"]');
  var size = form.querySelector('[name="contact[Size preference]"]');

  proxyRequest(root, '/campaign?edition=' + encodeURIComponent(editionId))
    .then(function(payload){
      liveStandbyOpen = Boolean(payload && payload.edition && payload.edition.state === 'reservation_full');
      if(size && payload && payload.edition){
        syncSizeSelect(size, payload.edition.sizeOptions || []);
      }
      if(liveForm) liveForm.hidden = !liveStandbyOpen;
      if(locked) locked.hidden = liveStandbyOpen;
    })
    .catch(function(){
      liveStandbyOpen = false;
      if(liveForm) liveForm.hidden = true;
      if(locked) locked.hidden = false;
    });

  form.addEventListener('submit', function(event){
    event.preventDefault();
    if(!submit || !liveStandbyOpen) return;

    submit.disabled = true;
    submit.classList.add('is-busy');
    submit.textContent = 'Joining standby…';
    if(result) result.hidden = true;

    proxyRequest(root, '/standby/join?edition=' + encodeURIComponent(editionId), {
      method: 'POST',
      body: {
        email: email ? email.value : '',
        country: country ? country.value : '',
        size: size ? size.value : ''
      }
    })
    .then(function(payload){
      if(result){
        result.textContent = 'STANDBY CONFIRMED · QUEUE POSITION #' +
          String(payload.standby.sequence).padStart(2, '0') + '.';
        result.hidden = false;
      }
      qsa('input, select', form).forEach(function(input){ input.disabled = true; });
      submit.textContent = 'Standby confirmed';
    })
    .catch(function(error){
      if(result){
        result.textContent = engineErrorMessage(error.code);
        result.hidden = false;
      }
      submit.disabled = false;
      submit.classList.remove('is-busy');
      submit.textContent = 'Join standby · free';
    });
  });
}

function mountCollector(root){
  if(root.dataset.phamCollectorMounted === 'true') return;
  root.dataset.phamCollectorMounted = 'true';

  var output = root.querySelector('[data-pham-payment-countdown]');
  var deadlineRow = root.querySelector('[data-pham-deadline-row]');
  var countdownRow = root.querySelector('[data-pham-countdown-row]');
  var deadlineLabel = root.querySelector('[data-pham-live-deadline]');
  var timer = null;

  function displayState(value){
    return String(value || 'pending').replace(/_/g, ' ').toUpperCase();
  }

  function displayDate(value){
    if(!value) return '—';
    var parsed = new Date(value);
    if(isNaN(parsed.getTime())) return String(value);
    try { return parsed.toLocaleString(); }
    catch (e) { return String(value); }
  }

  function renderLifecycle(stage){
    var rawStage = String(stage || 'not_started');
    var visibleStages = [
      'production_queued',
      'in_production',
      'quality_control',
      'packed',
      'dispatched',
      'delivered'
    ];
    var effectiveStage = rawStage === 'archived' ? 'delivered' : rawStage;
    var currentIndex = visibleStages.indexOf(effectiveStage);
    var status = root.querySelector('[data-pham-lifecycle-status]');
    if(status) status.textContent = displayState(rawStage);

    qsa('[data-pham-lifecycle-step]', root).forEach(function(step, index){
      step.classList.remove('is-complete', 'is-current');
      if(currentIndex < 0) return;
      if(rawStage === 'archived' || index < currentIndex) step.classList.add('is-complete');
      if(rawStage !== 'archived' && index === currentIndex) step.classList.add('is-current');
      if(rawStage === 'delivered' && index === currentIndex) step.classList.add('is-complete');
    });
  }

  function nextInstruction(reservation){
    if(reservation.status === 'final_payment_open'){
      return 'Complete the remaining acquisition balance before the published deadline. The allocation is released if the payment window expires.';
    }

    switch(String(reservation.lifecycleStage || 'not_started')){
      case 'production_queued':
        return 'Acquisition confirmed. Your object is queued for controlled production; no action is required.';
      case 'in_production':
        return 'Production is underway. PHAM will advance the record when the object enters final quality control.';
      case 'quality_control':
        return 'Your object is in final quality control. Packing begins only after inspection is cleared.';
      case 'packed':
        return 'The object, Identity materials and collector package are sealed. Dispatch details will appear here next.';
      case 'dispatched':
        return 'Your object has left PHAM. Use the tracking control in this record for carrier updates.';
      case 'delivered':
        return 'Delivery is recorded. The Founder’s Token is now revealed and the Birth Record remains attached to the object.';
      case 'archived':
        return 'This object is now part of the permanent PHAM archive. The edition will not return to production.';
      default:
        return 'Your reservation is recorded. PHAM will surface the next required action here as the edition advances.';
    }
  }

  function startCountdown(rawDeadline){
    if(!output || !rawDeadline) return;

    var deadline = new Date(rawDeadline);
    if(isNaN(deadline.getTime())){
      output.textContent = 'SEE DEADLINE ABOVE';
      return;
    }

    root.dataset.paymentDeadline = rawDeadline;
    if(deadlineRow) deadlineRow.hidden = false;
    if(countdownRow) countdownRow.hidden = false;
    if(deadlineLabel) deadlineLabel.textContent = displayDate(rawDeadline);

    if(timer) window.clearInterval(timer);

    function renderCountdown(){
      var diff = deadline.getTime() - Date.now();
      if(diff <= 0){
        output.textContent = 'WINDOW EXPIRED';
        return false;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var minutes = Math.floor((totalSeconds % 3600) / 60);
      var seconds = totalSeconds % 60;

      var parts = [];
      if(days > 0) parts.push(days + 'D');
      parts.push(String(hours).padStart(2,'0') + 'H');
      parts.push(String(minutes).padStart(2,'0') + 'M');
      parts.push(String(seconds).padStart(2,'0') + 'S');
      output.textContent = parts.join(' ');
      return true;
    }

    if(renderCountdown()){
      timer = window.setInterval(function(){
        if(!renderCountdown()){
          window.clearInterval(timer);
          timer = null;
        }
      }, 1000);
    }
  }

  if(root.dataset.paymentDeadline) startCountdown(root.dataset.paymentDeadline);
  renderLifecycle('not_started');

  if(root.dataset.engineEnabled !== 'true') return;

  proxyRequest(root, '/status')
    .then(function(payload){
      var reservation = payload.reservation || {};
      var identity = payload.identity || {};
      var referral = payload.referral || {};
      var editionSize = root.dataset.editionSize || '50';
      var productCode = root.dataset.productCode || 'PHAM-001';

      var statusEl = root.querySelector('[data-pham-live-reservation-status]');
      var objectEl = root.querySelector('[data-pham-live-object]');
      var identityEl = root.querySelector('[data-pham-live-identity-status]');
      var lifecycleEl = root.querySelector('[data-pham-live-lifecycle]');
      var acquiredEl = root.querySelector('[data-pham-live-acquired]');
      var sizeEl = root.querySelector('[data-pham-live-size]');
      var referralEl = root.querySelector('[data-pham-live-referral]');
      var lookbookEl = root.querySelector('[data-pham-live-lookbook]');
      var founderTokenEl = root.querySelector('[data-pham-live-founder-token]');
      var recordIdEl = root.querySelector('[data-pham-live-record-id]');
      var lookbookCopyEl = root.querySelector('[data-pham-live-lookbook-copy]');
      var balanceEl = root.querySelector('[data-pham-live-balance]');
      var finalPaymentLink = root.querySelector('[data-pham-final-payment-link]');
      var birthRecordLink = root.querySelector('[data-pham-birth-record-link]');
      var trackingRow = root.querySelector('[data-pham-tracking-row]');
      var trackingEl = root.querySelector('[data-pham-live-tracking]');
      var trackingLink = root.querySelector('[data-pham-tracking-link]');
      var nextAction = root.querySelector('[data-pham-next-action-copy]');

      if(statusEl) statusEl.textContent = displayState(reservation.status);
      if(objectEl){
        objectEl.textContent = reservation.objectNumber
          ? productCode + ' · ' + String(reservation.objectNumber).padStart(2,'0') + ' / ' + editionSize
          : productCode + ' · PENDING ASSIGNMENT';
      }
      if(identityEl) identityEl.textContent = displayState(identity.status);
      if(lifecycleEl) lifecycleEl.textContent = displayState(reservation.lifecycleStage || 'not_started');
      if(acquiredEl) acquiredEl.textContent = displayDate(reservation.acquiredAt);
      if(sizeEl) sizeEl.textContent = reservation.sizePreference || 'PENDING';
      if(referralEl){
        referralEl.textContent = String(referral.verifiedCount || 0) + ' / ' +
          String(referral.requiredCount || 1) + ' VERIFIED';
      }
      if(lookbookEl) lookbookEl.textContent = displayState(reservation.lookbookStatus);
      if(founderTokenEl) founderTokenEl.textContent = displayState(reservation.founderTokenType || 'pending_allocation');
      if(recordIdEl) recordIdEl.textContent = reservation.objectRecordId || 'PENDING';
      if(lookbookCopyEl) lookbookCopyEl.textContent = displayState(reservation.lookbookStatus);
      if(balanceEl && reservation.balanceDueCents != null){
        balanceEl.textContent = formatMoney(
          reservation.balanceDueCents,
          root.dataset.currency || 'USD'
        );
      }
      if(nextAction) nextAction.textContent = nextInstruction(reservation);

      renderLifecycle(reservation.lifecycleStage || 'not_started');

      if(finalPaymentLink){
        var canPay = reservation.status === 'final_payment_open' && Boolean(reservation.invoiceUrl);
        if(canPay){
          finalPaymentLink.href = reservation.invoiceUrl;
          finalPaymentLink.hidden = false;
          finalPaymentLink.textContent = 'COMPLETE ACQUISITION · ' +
            formatMoney(reservation.balanceDueCents, root.dataset.currency || 'USD');
        } else {
          finalPaymentLink.hidden = true;
          finalPaymentLink.removeAttribute('href');
        }
      }

      if(birthRecordLink){
        if(reservation.provenanceUrl){
          birthRecordLink.href = reservation.provenanceUrl;
          birthRecordLink.hidden = false;
        } else {
          birthRecordLink.hidden = true;
          birthRecordLink.removeAttribute('href');
        }
      }

      if(trackingRow){
        trackingRow.hidden = !(reservation.trackingNumber || reservation.trackingUrl);
      }
      if(trackingEl){
        trackingEl.textContent = reservation.trackingNumber ||
          (reservation.trackingUrl ? 'AVAILABLE' : '—');
      }
      if(trackingLink){
        if(reservation.trackingUrl){
          trackingLink.href = reservation.trackingUrl;
          trackingLink.hidden = false;
        } else {
          trackingLink.hidden = true;
          trackingLink.removeAttribute('href');
        }
      }

      if(reservation.paymentDeadline && reservation.status === 'final_payment_open'){
        startCountdown(reservation.paymentDeadline);
      } else {
        if(deadlineRow) deadlineRow.hidden = true;
        if(countdownRow) countdownRow.hidden = true;
      }
    })
    .catch(function(error){
      if(error && error.code === 'customer_login_required') return;
      // Shopify metafields remain the safe fallback if the Edition Engine is unavailable.
    });
}

function mountProvenance(root){
  if(root.dataset.phamProvenanceMounted === 'true') return;
  root.dataset.phamProvenanceMounted = 'true';

  if(root.dataset.engineEnabled !== 'true') return;

  var params = new URLSearchParams(window.location.search);
  var token = params.get('token') || '';
  if(!token) return;

  function displayState(value){
    return String(value || 'pending').replace(/_/g, ' ').toUpperCase();
  }

  function displayDate(value){
    if(!value) return '—';
    var parsed = new Date(value);
    if(isNaN(parsed.getTime())) return String(value);
    try { return parsed.toLocaleString(); }
    catch (e) { return String(value); }
  }

  var result = root.querySelector('[data-pham-provenance-result]');

  proxyRequest(root, '/provenance?token=' + encodeURIComponent(token))
    .then(function(payload){
      var object = payload.object || {};
      var product = root.querySelector('[data-pham-provenance-product]');
      var number = root.querySelector('[data-pham-provenance-number]');
      var auth = root.querySelector('[data-pham-provenance-auth]');
      var edition = root.querySelector('[data-pham-provenance-edition]');
      var design = root.querySelector('[data-pham-provenance-design-origin]');
      var designCopy = root.querySelector('[data-pham-provenance-design-origin-copy]');
      var assignment = root.querySelector('[data-pham-provenance-assignment]');
      var identity = root.querySelector('[data-pham-provenance-identity]');
      var tokenType = root.querySelector('[data-pham-provenance-token]');
      var recordId = root.querySelector('[data-pham-provenance-record-id]');
      var size = root.querySelector('[data-pham-provenance-size]');
      var acquired = root.querySelector('[data-pham-provenance-acquired]');
      var birthRecorded = root.querySelector('[data-pham-provenance-birth-recorded]');
      var lifecycle = root.querySelector('[data-pham-provenance-lifecycle]');

      if(product) product.textContent = object.productCode || 'PHAM OBJECT';
      if(number){
        number.textContent = 'OBJECT ' +
          String(object.objectNumber || '—').padStart(2,'0') +
          ' / ' + String(object.editionSize || '—');
      }
      if(auth) auth.textContent = payload.authenticated ? 'AUTHENTICATED' : 'UNVERIFIED';
      if(edition) edition.textContent = object.editionLabel || '';
      if(design) design.textContent = object.designOrigin || '';
      if(designCopy) designCopy.textContent = object.designOrigin || '';
      if(assignment){
        assignment.textContent = 'Assigned as Object ' +
          String(object.objectNumber || '—').padStart(2,'0') +
          ' / ' + String(object.editionSize || '—') + '.';
      }
      if(identity){
        identity.textContent = object.publicIdentity ||
          'Collector identity remains private unless the collector explicitly opts into public display.';
      }
      if(tokenType) tokenType.textContent = displayState(object.tokenType || 'pending_allocation');
      if(recordId) recordId.textContent = object.recordId || '—';
      if(size) size.textContent = object.size || '—';
      if(acquired) acquired.textContent = displayDate(object.acquiredAt);
      if(birthRecorded) birthRecorded.textContent = displayDate(object.birthRecordedAt);
      if(lifecycle) lifecycle.textContent = displayState(object.lifecycleStage || 'not_started');
      if(result){
        result.textContent = 'AUTHENTIC PHAM BIRTH RECORD · TOKEN VERIFIED';
        result.hidden = false;
      }
    })
    .catch(function(error){
      if(result){
        result.textContent = 'BIRTH RECORD NOT VERIFIED · ' +
          (error.code === 'provenance_not_found' ? 'TOKEN NOT RECOGNIZED' : 'UNABLE TO VERIFY TOKEN');
        result.hidden = false;
      }

      var auth = root.querySelector('[data-pham-provenance-auth]');
      if(auth) auth.textContent = 'UNVERIFIED';
    });
}

function mountLiveCampaign(root){
  if(root.dataset.phamLiveMounted === 'true') return;
  root.dataset.phamLiveMounted = 'true';

  if(root.dataset.engineEnabled !== 'true') return;

  var editionId = root.dataset.editionId || 'edition-01';

  proxyRequest(root, '/campaign?edition=' + encodeURIComponent(editionId))
    .then(function(payload){
      if(!payload || !payload.edition || !payload.counters) return;

      var reservations = Number(payload.counters.reserved || 0);
      var editionSize = Number(payload.edition.editionSize || 0);
      var identities = Number(payload.counters.identityClaimed || 0);
      var identityLimit = Number(payload.edition.identityLimit || 0);
      var context = readCampaignContext() || {};
      var liveState = effectiveCampaignState(context, payload.edition.state);
      var presentation = campaignPresentation(context, liveState);

      var stateText = root.querySelector('[data-pham-live-state]');
      var liveActions = root.querySelector('[data-pham-live-actions]');
      if(stateText){
        stateText.textContent = presentation && presentation.status
          ? presentation.status
          : 'PRELAUNCH · SYSTEM IN PREPARATION';
      }
      if(liveActions){
        var actionLabel = null;
        if(liveState === 'reservation_open') actionLabel = 'RESERVE ' + (context.productCode || context.product || 'PHAM-001');
        else if(liveState === 'reservation_full') actionLabel = 'JOIN STANDBY · FREE';
        else if(liveState === 'final_payment') actionLabel = 'COLLECTOR ACCESS';

        liveActions.replaceChildren();
        if(actionLabel && presentation){
          var actionLink = document.createElement('a');
          actionLink.className = 'pham-campaign-btn';
          actionLink.href = presentation.url;
          actionLink.textContent = actionLabel;
          liveActions.appendChild(actionLink);
        }else{
          var disabledAction = document.createElement('span');
          disabledAction.className = 'pham-campaign-btn';
          disabledAction.setAttribute('aria-disabled', 'true');
          disabledAction.textContent = liveState === 'sold_out' ? 'EDITION CLOSED' : liveState === 'archived' ? 'ARCHIVED' : 'NOT YET OPEN';
          liveActions.appendChild(disabledAction);
        }
      }

      var reservationText = root.querySelector('[data-pham-live-reservations]');
      var identityText = root.querySelector('[data-pham-live-identity]');
      var acquiredText = root.querySelector('[data-pham-live-acquired-count]');
      var deliveredText = root.querySelector('[data-pham-live-delivered-count]');
      var designOrigin = root.querySelector('[data-pham-live-design-origin]');
      var archiveNote = root.querySelector('[data-pham-live-archive-note]');
      var reservationMeter = root.querySelector('[data-pham-live-reservation-meter]');
      var identityMeter = root.querySelector('[data-pham-live-identity-meter]');

      if(reservationText) reservationText.textContent = reservations + ' / ' + editionSize;
      if(identityText) identityText.textContent = identities + ' / ' + identityLimit;
      if(acquiredText) acquiredText.textContent = Number(payload.counters.acquired || 0) + ' / ' + editionSize;
      if(deliveredText) deliveredText.textContent = Number(payload.counters.delivered || 0) + ' / ' + editionSize;
      if(designOrigin && payload.edition.designOrigin) designOrigin.textContent = payload.edition.designOrigin;
      if(archiveNote && payload.edition.archivePermanent){
        archiveNote.textContent = 'ARCHIVE SEALED · This edition is permanently closed. Its object set and Birth Records remain in the PHAM archive; production will not reopen.';
      }

      if(reservationMeter && editionSize > 0){
        reservationMeter.style.setProperty('--pc-progress', Math.min(100, reservations / editionSize * 100) + '%');
      }
      if(identityMeter && identityLimit > 0){
        identityMeter.style.setProperty('--pc-progress', Math.min(100, identities / identityLimit * 100) + '%');
      }
    })
    .catch(function(){ /* Theme settings remain the safe fallback. */ });
}

function mount(){
  captureReferral();
  mountGlobalCampaignRuntime();
  qsa('[data-pham-identity-configurator]').forEach(mountIdentity);
  qsa('[data-pham-referral-hub]').forEach(mountReferral);
  qsa('[data-pham-reservation-gateway]').forEach(mountReservation);
  qsa('[data-pham-standby]').forEach(mountStandby);
  qsa('[data-pham-collector-status]').forEach(mountCollector);
  qsa('[data-pham-edition-campaign]').forEach(mountLiveCampaign);
  qsa('[data-pham-provenance-record]').forEach(mountProvenance);
}

if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
else mount();

document.addEventListener('shopify:section:load', mount);
})();
